import React, { Component } from "react";
import PropTypes from "prop-types";
import { service, actions } from "./data";
import { injectIntl, intlShape } from "react-intl";
import { withCrud, withMasked } from "~/hocs";
import { DataTable } from "~/core";
import { FormattingHelpers } from "@ai360/core";
import { messages } from "../../i18n-messages";

export class ProductLog_ extends Component {
    static propTypes = {
        records: PropTypes.array,
        intl: intlShape.isRequired,
    };
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.records) {
            for (const item of nextProps.records) {
                FormattingHelpers.formatLogDetailText(item);
            }
        }
    }
    render() {
        return (
            <DataTable
                service={service}
                isCheckbox={false}
                showFilterInput={false}
                messages={messages}
                {...this.props}
            />
        );
    }
}
export const ProductLog = injectIntl(withMasked(withCrud(ProductLog_, service, actions)));
